import { Tree as FluentTree } from "@fluentui/web-components";
/**
 * Tree
 * @summary A Fabric UI Tree component that extends Fluent UI's Tree with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-tree size="medium" appearance="subtle">
 *   <fabric-tree-item expanded>
 *     Root Item
 *     <fabric-tree-item>Child Item 1</fabric-tree-item>
 *     <fabric-tree-item selected>Child Item 2</fabric-tree-item>
 *   </fabric-tree-item>
 * </fabric-tree>
 * ```
 *
 * @attr {string | undefined} size - The size of tree items within this tree (small, medium).
 * @attr {string | undefined} appearance - The appearance variant of tree items (subtle, subtleAlpha, transparent).
 *
 * @prop {string} size - The size of tree items within this tree.
 * @prop {string} appearance - The appearance variant of tree items.
 * @prop {HTMLElement | null} currentSelected - The currently selected tree item.
 * @prop {Array} childTreeItems - Array of immediate child tree items.
 *
 * @slot default - Container for tree-item elements that make up the tree structure.
 *
 * @csspart root - The component's outermost element.
 *
 * @method keydownHandler - Handles keyboard navigation (arrow keys, home, end, enter, space).
 * @method focusHandler - Manages focus behavior when tree receives focus.
 * @method blurHandler - Manages focus behavior when tree loses focus.
 * @method clickHandler - Handles click events from child tree items.
 * @method changeHandler - Handles selection change events from child tree items.
 * @method updateSizeAndAppearance - Updates size and appearance of all child tree items.
 *
 * @fires change - Fired when a tree item selection changes.
 *
 * @extends FluentTree
 * @tagname fabric-tree
 * @public
 */
export class Tree extends FluentTree {
}
//# sourceMappingURL=tree.js.map